import { useQuery } from '@tanstack/react-query';
import { getExecutionDetailMetrics } from '@/services/composer-dashboard/get-execution-detail-metrics';
import { ExecutionDetailMetricsResponse } from '@/types/composer-dashboard';
import { useOrgStore } from '@/stores/org-store';

export const useGetExecutionDetailMetrics = (labelIds?: string[]) => {
  const { currentOrg } = useOrgStore();
  const orgId = currentOrg?.orgid;

  return useQuery<ExecutionDetailMetricsResponse, Error>({
    queryKey: ['composer-execution-detail-metrics', orgId, labelIds ?? []],
    queryFn: () => getExecutionDetailMetrics(orgId!, labelIds),
    enabled: !!orgId,
    retry: 1,
    staleTime: 60000,
  });
};
